var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoLogin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 168,
    height: 168,
    viewBox: "0 0 168 168",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67.6478 55.8583L51.2673 46.3927V65.2672L51.324 65.2955L67.6478 55.8583Z",
    fill: "url(#paint0_linear_1_24)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M67.6478 74.7328L51.2673 84.17L84.0001 103.073V84.17L67.6478 74.7328Z",
    fill: "url(#paint1_linear_1_24)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M116.704 65.2955L100.352 55.8583L84 65.2955L67.6477 55.8583L51.3239 65.2955L67.6477 74.7328L84 84.17L100.352 74.7044L116.704 65.2672V65.2955Z",
    fill: "url(#paint2_linear_1_24)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M100.381 74.7328L84.0283 84.1701H84V103.073L100.352 93.6356L116.733 84.1701V65.2956L100.381 74.7328Z",
    fill: "url(#paint3_linear_1_24)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M84.0001 27.5182L67.6478 36.9554L51.2673 46.3927L67.6478 55.8583L84.0001 65.2955L100.352 55.8583L116.733 46.3927L84.0001 27.5182Z",
    fill: "url(#paint4_linear_1_24)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9432 139.688C21.5824 139.954 22.2471 140.153 22.927 140.283C23.7691 140.429 24.6231 140.495 25.4776 140.482C26.433 140.49 27.3854 140.376 28.3116 140.142C29.0942 139.935 29.8332 139.589 30.4938 139.121C31.091 138.667 31.5678 138.074 31.8824 137.393C32.2396 136.631 32.4142 135.796 32.3925 134.955C32.4172 134.248 32.2917 133.542 32.0242 132.887C31.8208 132.351 31.5014 131.867 31.0889 131.47C30.7112 131.078 30.2706 130.752 29.7853 130.506C29.2902 130.271 28.7787 130.072 28.2549 129.911L26.7813 129.571L25.4776 129.316L23.9756 128.947L22.5302 128.494C22.1225 128.338 21.7475 128.108 21.4249 127.814C21.2625 127.673 21.1327 127.499 21.0446 127.303C20.9565 127.108 20.9121 126.895 20.9148 126.68C20.9086 126.271 21.0609 125.875 21.3399 125.575C21.5988 125.276 21.9174 125.035 22.2752 124.866C22.6498 124.675 23.051 124.541 23.4654 124.47C23.8234 124.432 24.1844 124.432 24.5424 124.47C25.4612 124.47 26.3727 124.633 27.2347 124.951C28.0921 125.308 28.909 125.754 29.6719 126.283L31.429 123.818C30.9189 123.449 30.4371 123.166 29.9837 122.883C29.4965 122.592 28.9844 122.345 28.4533 122.146C27.9139 121.941 27.353 121.798 26.7813 121.721C26.0983 121.601 25.4058 121.544 24.7124 121.551C23.9029 121.554 23.0958 121.64 22.3035 121.806C21.5014 121.961 20.7337 122.259 20.0363 122.684C19.3706 123.091 18.8157 123.655 18.4209 124.328C17.9599 125.128 17.734 126.041 17.7691 126.964C17.7517 127.607 17.8774 128.246 18.1375 128.834C18.3481 129.349 18.6671 129.813 19.0728 130.194C19.4659 130.58 19.915 130.905 20.4047 131.158C20.8939 131.414 21.4064 131.623 21.9351 131.781C22.4362 131.946 22.9473 132.079 23.4654 132.178L24.7691 132.433L26.4128 132.745C26.8953 132.862 27.3688 133.014 27.8298 133.198C28.2106 133.368 28.5493 133.62 28.8217 133.935C29.1007 134.235 29.253 134.631 29.2468 135.04C29.2396 135.386 29.1523 135.726 28.9918 136.032C28.8003 136.375 28.5398 136.674 28.2266 136.911C27.8532 137.17 27.4422 137.371 27.0079 137.506C26.484 137.663 25.9394 137.739 25.3926 137.733C24.2746 137.728 23.1714 137.476 22.1618 136.996C21.1719 136.563 20.2234 136.041 19.3278 135.437L17.6274 137.931L19.1294 138.951C19.6794 139.285 20.2579 139.57 20.8582 139.802",
    fill: "#231815"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M48.7732 140.142H51.9189V121.721H48.7732V129.883H39.0242V121.721H35.8784V140.142H39.0242V132.632H48.7732V140.142Z",
    fill: "#231815"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M58.3239 137.676C59.2001 138.545 60.2278 139.246 61.3563 139.745C62.5329 140.234 63.7948 140.484 65.0689 140.482C66.3432 140.486 67.6055 140.236 68.7814 139.745C69.9179 139.26 70.9481 138.557 71.8138 137.676C72.6952 136.81 73.3981 135.78 73.8826 134.644C74.3764 133.469 74.6271 132.206 74.6195 130.931C74.6217 129.657 74.3713 128.395 73.8826 127.219C73.3981 126.082 72.6952 125.052 71.8138 124.186C70.9481 123.305 69.9179 122.602 68.7814 122.117C67.6055 121.627 66.3432 121.376 65.0689 121.38C63.7948 121.378 62.5329 121.629 61.3563 122.117C60.2278 122.616 59.2001 123.317 58.3239 124.186C57.4603 125.061 56.7681 126.089 56.2835 127.219C55.7819 128.391 55.5309 129.656 55.5466 130.931C55.5249 132.207 55.7761 133.473 56.2835 134.644C56.7681 135.773 57.4603 136.802 58.3239 137.676ZM59.2025 128.409C59.5228 127.624 59.9838 126.903 60.5627 126.283C61.1406 125.684 61.8224 125.194 62.575 124.838C63.3545 124.471 64.2075 124.287 65.0689 124.3C65.9393 124.289 66.801 124.473 67.5911 124.838C68.3437 125.194 69.0254 125.684 69.6032 126.283C70.1725 126.911 70.6323 127.629 70.9636 128.409C71.3033 129.206 71.4768 130.064 71.4737 130.931C71.4744 131.807 71.3011 132.674 70.9636 133.482C70.6319 134.253 70.1719 134.962 69.6032 135.579C69.0341 136.196 68.3508 136.696 67.5911 137.053C66.801 137.418 65.9393 137.602 65.0689 137.591C64.2075 137.603 63.3545 137.419 62.575 137.053C61.8153 136.696 61.1319 136.196 60.5627 135.579C59.9847 134.969 59.5236 134.258 59.2025 133.482C58.865 132.674 58.6916 131.807 58.6924 130.931C58.6892 130.064 58.8628 129.206 59.2025 128.409Z",
    fill: "#231815"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M82.6397 140.142L87.9393 128.862L93.1822 140.142H93.2388L100.097 121.749H96.753L92.8421 132.49L87.9109 121.806L82.9797 132.462L79.1538 121.749H75.8097L82.6113 140.142H82.6397Z",
    fill: "#231815"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M118.887 140.142V121.749H115.741V133.425L103.045 121.749H102.96V140.142H106.105V128.636L118.802 140.142H118.887Z",
    fill: "#231815"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M127.134 121.749H123.988V140.113H127.134V121.749Z",
    fill: "#231815"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M134.02 137.676C134.886 138.558 135.916 139.26 137.053 139.745C138.219 140.234 139.472 140.484 140.737 140.482C142.02 140.487 143.292 140.237 144.478 139.745C145.106 139.467 145.704 139.125 146.263 138.725H146.433L148.219 140.51L150.117 138.611L148.36 136.826C148.79 136.226 149.152 135.579 149.437 134.899C150.055 133.676 150.384 132.329 150.401 130.959C150.408 129.682 150.147 128.418 149.636 127.247C149.151 126.118 148.459 125.089 147.595 124.215C146.719 123.346 145.691 122.645 144.563 122.146C143.377 121.654 142.105 121.404 140.822 121.409C139.557 121.407 138.304 121.657 137.138 122.146C136.001 122.63 134.971 123.333 134.105 124.215C133.233 125.082 132.54 126.112 132.065 127.247C131.553 128.418 131.293 129.682 131.3 130.959C131.288 132.237 131.549 133.503 132.065 134.672C132.54 135.807 133.233 136.837 134.105 137.704M134.955 128.437C135.287 127.658 135.747 126.939 136.316 126.312C136.904 125.711 137.595 125.222 138.356 124.866C139.136 124.5 139.989 124.316 140.85 124.328C141.712 124.316 142.565 124.5 143.344 124.866C144.097 125.223 144.778 125.712 145.356 126.312C145.944 126.93 146.414 127.651 146.745 128.437C147.062 129.24 147.226 130.096 147.227 130.959C147.223 131.832 147.06 132.696 146.745 133.51L146.348 134.275L146.206 134.53L143.854 132.178L141.955 134.077L144.364 136.486L144.138 136.628C143.889 136.804 143.623 136.956 143.344 137.081C142.565 137.448 141.712 137.632 140.85 137.619C139.989 137.632 139.136 137.448 138.356 137.081C137.588 136.725 136.895 136.225 136.316 135.607C135.747 134.99 135.287 134.281 134.955 133.51C134.618 132.702 134.445 131.835 134.445 130.959C134.442 130.093 134.616 129.235 134.955 128.437Z",
    fill: "#231815"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_24",
    x1: 51.2956,
    y1: 65.2672,
    x2: 59.4576,
    y2: 51.1255,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8C9CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#BDBDBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#959494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#757373"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#5E5C5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#514E4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#4C4948"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231815"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_24",
    x1: 67.6478,
    y1: 103.073,
    x2: 67.6478,
    y2: 74.7328,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8C9CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#BDBDBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#959494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#757373"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#5E5C5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#514E4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#4C4948"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231815"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_24",
    x1: 84.0283,
    y1: 84.1983,
    x2: 84.0283,
    y2: 55.8583,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8C9CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#BDBDBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#959494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#757373"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#5E5C5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#514E4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#4C4948"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231815"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1_24",
    x1: 92.1903,
    y1: 76.0081,
    x2: 108.543,
    y2: 92.3603,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8C9CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#BDBDBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#959494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#757373"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#5E5C5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#514E4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#4C4948"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231815"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1_24",
    x1: 84.0001,
    y1: 65.2955,
    x2: 84.0001,
    y2: 27.5182,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8C9CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#BDBDBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#959494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#757373"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#5E5C5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#514E4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#4C4948"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231815"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLogin);
export default __webpack_public_path__ + "static/media/LogoLogin.402e1565.svg";
export { ForwardRef as ReactComponent };